/**
 * Front-end entry.
 *
 * Imports the main stylesheet (so Vite emits dist/css/main.css) and boots the
 * behaviour modules. Feature modules are added in later phases (ISI tray, nav,
 * form, dataLayer); each guards on the presence of its target elements.
 */
import '../scss/main.scss';
import { initA11y } from './modules/a11y.js';
import { initIsiTray } from './modules/isi-tray.js';
import { initMobileMenu } from './modules/mobile-menu.js';
import { initCookieBanner } from './modules/cookie-banner.js';
import { initForm } from './modules/form.js';
import { initTcModal } from './modules/tc-modal.js';
import { initLeavingSiteModal } from './modules/leaving-site.js';
import { initNowAvailableModal } from './modules/now-available-modal.js';

const ready = (fn) =>
  document.readyState !== 'loading'
    ? fn()
    : document.addEventListener('DOMContentLoaded', fn);

ready(() => {
  initA11y();
  initIsiTray();
  initMobileMenu();
  initCookieBanner();
  initForm();
  initTcModal();
  initLeavingSiteModal();
  initNowAvailableModal();
  // Phase 6: initDataLayer();
});
